import * as React from 'react';

import { ColorWheelIcon } from './ColorWheelIcon';
import { ColorPickerDropdown } from './ColorPickerDropdown';
import { RecentColorsLsManager } from './RecentColorsLsManager';

import { PREDEFINED_MODE } from './ColorPicker';

import l10n from '../../util/l10n';

interface ColorPickerCKEditorDropdownProps extends React.Props<ColorPickerCKEditorDropdown> {
    ckEditor: CKEditor;
    onChange: (hexColor?: string) => void;
}

export class ColorPickerCKEditorDropdown extends React.Component<ColorPickerCKEditorDropdownProps, {}> {

    render() {
        const hexColor = this.getSelectionColor();

        return (
            <ColorPickerDropdown
                Icon={<ColorWheelIcon />}
                text={l10n('module.text.color')}
                hexColor={hexColor}
                initialMode={this.getInitialMode()}
                recentColors={RecentColorsLsManager.getRecentColors()}
                onChange={this.onColorChange}
            />
        );
    }

    private getInitialMode = () => {
        const selection = this.props.ckEditor.getSelection();
        const selectedElement = selection.getStartElement();

        // We decided to settle for the "easy" approach.
        // This does not cover all cases, but it works for the most.
        if (!selectedElement.$.style.color) {
            return PREDEFINED_MODE;
        }

        return null;
    };

    private getSelectionColor = () => {
        const selection = this.props.ckEditor.getSelection();
        const selectedElement = selection.getStartElement();
        const elementColor = selectedElement.getComputedStyle('color');

        return CKEDITOR.tools.convertRgbToHex(elementColor).split('#')[1].toUpperCase();
    };

    private onColorChange = (hexColor: string, isDefaultColor: boolean) => {
        if (!isDefaultColor) {
            RecentColorsLsManager.saveColor(hexColor);
        }

        this.props.onChange(isDefaultColor ? void 0 : hexColor);
    };

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/ColorPickerCKEditorDropdown.tsx
 **/